/* eslint react/jsx-filename-extension: 0 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

const root = document.querySelector('#root');
const container = createRoot(root);
container.render(<App />);
